import React, { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { StateContext } from 'context';
import { LogoTipo } from 'assets/logos';
import './header.css';

import useScrollPosition from '@react-hook/window-scroll';
import { Themes } from 'styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import Dropdown from 'rc-dropdown';
import 'rc-dropdown/assets/index.css';


const Header = (props) => {
    const scrollY = useScrollPosition(60);
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    const [openMenuMobile, setOpenMenuMobile] = useState(false);
    let navigate = useNavigate();

    useEffect(() => {
    }, []);

    const inicio = () => {
        setOpenMenuMobile(false);
        navigate('/');
        props.scrollTop();
    };
    const navegar = (target) => {
        setOpenMenuMobile(false);
        setTimeout(() => {
            navigate(target);
            props.scrollTop();
        }, 200);

    };
    const scrollear = (target) => {
        setOpenMenuMobile(false);
        props.scrollear(target);
    };

    const menuServicios = (<div className="w3-card w3-round w3-white">
        <div className="w3-block"><button className="w3-transparent w3-border-0 w3-text-theme w3-btn w3-block" onClick={() => navegar('prestamos')}>PRÉSTAMOS</button></div>
        {/* <div className="w3-block"><button className="w3-transparent w3-border-0 w3-text-theme w3-btn w3-block" onClick={() => navegar('unipersonal-empresa')}>UNIPERSONAL - EMPRESA</button></div> */}
        <div className="w3-block"><button className="w3-transparent w3-border-0 w3-text-theme w3-btn w3-block" onClick={() => navegar('descuento-de-cheques')}>DESCUENTO DE CHEQUES</button></div>
        <div className="w3-block"><button className="w3-transparent w3-border-0 w3-text-theme w3-btn w3-block" onClick={() => navegar('asociaciones-de-empleados')}>ASOCIACIONES DE EMPLEADOS</button></div>
        <div className="w3-block"><button className="w3-transparent w3-border-0 w3-text-theme w3-btn w3-block" onClick={() => navegar('creditos-de-turismo')}>CRÉDITOS DE TURISMO</button></div>
    </div>);

    const menuServiciosMobile = (<div style={{ backgroundColor: Themes[indexTema].D2, width: '100%', textAlign: 'center' }} className="w3-card w3-round">
        <div className="w3-block"><button className="w3-btn w3-transparent w3-border-0 w3-text-white w3-block" onClick={() => navegar('prestamos')}>PRÉSTAMOS</button></div>
        {/* <div className="w3-block"><button className="w3-btn w3-transparent w3-border-0 w3-text-white w3-block" onClick={() => navegar('unipersonal-empresa')}>UNIPERSONAL - EMPRESA</button></div> */}
        <div className="w3-block"><button className="w3-btn w3-transparent w3-border-0 w3-text-white w3-block" onClick={() => navegar('descuento-de-cheques')}>DESCUENTO DE CHEQUES</button></div>
        <div className="w3-block"><button className="w3-btn w3-transparent w3-border-0 w3-text-white w3-block" onClick={() => navegar('asociaciones-de-empleados')}>ASOCIACIONES DE EMPLEADOS</button></div>
        <div className="w3-block"><button className="w3-btn w3-transparent w3-border-0 w3-text-white w3-block" onClick={() => navegar('creditos-de-turismo')}>CRÉDITOS DE TURISMO</button></div>
    </div>);

    function onServiciosVisibleChange(visible) {
        console.log(visible);
    }

    const menuSolicita = (<div className="w3-card w3-round w3-white">
        <div className="w3-block"><button className="w3-transparent w3-border-0 w3-text-theme w3-btn w3-block" onClick={() => navegar('solicitud-de-prestamo')}>PRÉSTAMO</button></div>
        <div className="w3-block"><button className="w3-transparent w3-border-0 w3-text-theme w3-btn w3-block" onClick={() => navegar('solicitud-descuento-de-cheques')}>DESCUENTO DE CHEQUES</button></div>
    </div>);

    const menuSolicitaMobile = (<div style={{ backgroundColor: Themes[indexTema].D2, width: '100%', textAlign: 'center' }} className="w3-card w3-round">
        <div className="w3-block"><button className="w3-btn w3-transparent w3-border-0 w3-text-white w3-block" onClick={() => navegar('solicitud-de-prestamo')}>PRÉSTAMO</button></div>
        <div className="w3-block"><button className="w3-btn w3-transparent w3-border-0 w3-text-white w3-block" onClick={() => navegar('solicitud-descuento-de-cheques')}>DESCUENTO DE CHEQUES</button></div>
    </div>);


    function onSolicitaVisibleChange(visible) {
        console.log(visible);
    }
    return (
        <>
            <div className="w3-block w3-card w3-hide-small w3-hide-medium bs-bbox animate__animated animate__fadeInDown" style={{ position: 'fixed', zIndex: 20, backgroundColor: '#fff' }}>
                <div className="w3-block">
                    <div className="w3-content">
                        <div className="w3-row">
                            <div className="w3-col logo-cont">
                                <button className="w3-transparent" onClick={() => inicio()}><img src={LogoTipo} alt="LogoTipo" /></button>
                            </div>
                            <div className="w3-rest" style={{ height: '80px', paddingTop: '10px' }}>
                                {/* <div className="w3-block w3-right-align" style={{ paddingRight: '40px' }}>
                                    <a href="tel:0800118300" className="w3-xlarge w3-text-gray xbold text-decoration-none">Llamanos gratis al <span style={{ color: Themes[indexTema].D2 }}>0800 11 8300!</span></a>
                                </div> */}
                                <nav className="nav-menu w3-right">
                                    <ul>
                                        <li className="inline"><div className="w3-cell"><button className="btn-menu w3-transparent w3-border-0 w3-text-theme xno-seleccionable" onClick={() => inicio()}>INICIO</button></div></li>
                                        <li className="inline"><div className="w3-cell"><button className="btn-menu w3-transparent w3-border-0 w3-text-theme xno-seleccionable" onClick={() => navegar('nosotros')}>NOSOTROS</button></div></li>
                                        <li className="inline">
                                            <div className="w3-cell">
                                                <Dropdown
                                                    overlayClassName="overlay-menu"
                                                    trigger={['hover', 'click']}
                                                    overlay={menuServicios}
                                                    animation="slide-up"
                                                    onVisibleChange={onServiciosVisibleChange}>
                                                    <button className="btn-menu w3-transparent w3-border-0 w3-text-theme xno-seleccionable">PRODUCTOS / SERVICIOS</button>
                                                </Dropdown>
                                            </div>
                                        </li>
                                        <li className="inline">
                                            <div className="w3-cell">
                                                <Dropdown
                                                    overlayClassName="overlay-menu"
                                                    trigger={['hover', 'click']}
                                                    overlay={menuSolicita}
                                                    animation="slide-up"
                                                    onVisibleChange={onSolicitaVisibleChange}>
                                                    <button className="btn-menu w3-transparent w3-border-0 w3-text-theme xno-seleccionable">SOLICITÁ YA!</button>
                                                </Dropdown>
                                            </div>
                                        </li>
                                        <li className="inline"><div className="w3-cell"><button className="btn-menu w3-transparent w3-border-0 w3-text-theme xno-seleccionable" onClick={() => scrollear('contacto')}>CONTACTO</button></div></li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="header-mobile" className="w3-block w3-hide-large bs-bbox" style={{ position: 'fixed', zIndex: 20, backgroundColor: '#fff' }}>
                <div className="w3-block w3-card">
                    <div className="w3-content">
                        <div className="w3-row">
                            <div className="w3-col logo-cont">
                                <Link to="/"><img src={LogoTipo} alt="LogoTipo" /></Link>
                            </div>
                            <div className="w3-rest w3-padding bs-bbox">
                                {/* <div className="w3-block w3-right-align" style={{ paddingRight: '40px' }}>
                                    <a href="tel:0800118300" className="llamanos w3-text-gray xbold text-decoration-none">Llamanos gratis al <span style={{ color: Themes[indexTema].D2 }}>0800 11 8300!</span></a>
                                </div> */}
                                <button className="w3-button w3-transparent w3-text-theme w3-right w3-hover-none w3-hover-text-theme"
                                    onClick={() => setOpenMenuMobile(!openMenuMobile)}>
                                    <FontAwesomeIcon icon={faBars} size="3x"></FontAwesomeIcon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {openMenuMobile ? <div className="w3-block bs-bbox animate__animated animate__fadeIn" style={{ backgroundColor: Themes[indexTema].D1, padding: 0 }}>
                    <button className="w3-transparent w3-text-white w3-block w3-btn bs-bbox" onClick={() => inicio()}>INICIO</button>
                    <button className="w3-transparent w3-text-white w3-block w3-btn bs-bbox" onClick={() => navegar('nosotros')}>NOSOTROS</button>
                    <Dropdown
                        trigger={['click']}
                        overlay={menuServiciosMobile}
                        animation="slide-up"
                        onVisibleChange={onServiciosVisibleChange}>
                        <button className="w3-transparent w3-text-white w3-block w3-btn bs-bbox">PRODUCTOS / SERVICIOS</button>
                    </Dropdown>
                    <Dropdown
                        trigger={['click']}
                        overlay={menuSolicitaMobile}
                        animation="slide-up"
                        onVisibleChange={onSolicitaVisibleChange}>
                        <button className="w3-transparent w3-text-white w3-block w3-btn bs-bbox">SOLICITÁ YA!</button>
                    </Dropdown>
                    <button className="w3-transparent w3-text-white w3-block w3-btn bs-bbox" onClick={() => scrollear('contacto')}>CONTACTO</button>
                </div> : null}
            </div>
            <div className="w3-block" style={{ height: 102 }}></div>
        </>
    );
}
export default Header;